// This is an auto-generated file. Please do not edit directly.
// For instructions on editing source .json files, please see:
// https://git.hubteam.com/HubSpot/UIComponents/tree/master/HubStyleTokens
// ***********************************************************************
'use es6';

export const ICON_FONT_FAMILY = 'spacesword';
export const CODE_FALLBACK_FONT_STACK = 'Consolas, Monaco, Courier New, monospace';
export const CODE_FONT_FAMILY = 'Source Code Pro';
export const CODE_FONT_WEIGHT = '500';
export const WEB_FONT_REGULAR = 'Avenir Next W02';
export const WEB_FONT_BOLD = 'Avenir Next W02';
export const WEB_FONT_MEDIUM = 'Avenir Next W02';
export const WEB_FONT_DEMI_BOLD = 'Avenir Next W02';
export const WEB_FONT_ITALIC = 'Avenir Next W02';
export const WEB_FONT_REGULAR_WEIGHT = '400';
export const WEB_FONT_BOLD_WEIGHT = '700';
export const WEB_FONT_MEDIUM_WEIGHT = '500';
export const WEB_FONT_DEMI_BOLD_WEIGHT = '600';
export const WEB_FONT_ITALIC_WEIGHT = '400';
export const FALLBACK_FONT_STACK = 'Helvetica, Arial, sans-serif';
export const HEADING_FONT_SMOOTHING = 'antialiased';
export const PAGE_TITLE_FONT_WEIGHT = 'demibold';
export const HEADING_WEIGHT1 = 'bold';
export const HEADING_WEIGHT2 = 'regular';
export const HEADING_WEIGHT3 = 'medium';
export const HEADING_WEIGHT4 = 'demibold';
export const HEADING_WEIGHT5 = 'demibold';
export const HEADING_WEIGHT6 = 'demibold';
export const HEADING_WEIGHT7 = 'demibold';
export const HEADING_CASE6 = 'uppercase';
export const INPUT_VERTICAL_ALIGNMENT = 'middle';
export const TABLE_HEADER_FONT_WEIGHT = 'medium';
export const TABLE_HEADER_VERTICAL_ALIGNMENT = 'middle';
export const TABLE_CELL_VERTICAL_ALIGNMENT = 'middle';
export const TOOLTIP_SHADOW = '0 3px 8px rgba(0, 0, 0, .1)';
export const HOVERLAY_OPACITY = '0.85';